export const users = {
  full_name: "登録名",
  mail_address: "メールアドレス",
  index: {
    user_management: '会員検索'
  },
  form: {
    input_labels: {
      id: '会員コード',
      name: '名前',
      nickname: 'ニックネーム（チップ送付時に表示されます）',
      zip_code: '住所',
      avatar: 'プロフィール写真',
      birthday: '生年月日',
      gender: '性別',
      mail_address: 'メールアドレス',
      login_id: 'ログインID(半角英数字8文字以上)',
      status: '有効・無効',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
    },
    input_placeholder: {
      first_name: '姓',
      last_name: '名',
      nickname: 'ニックネーム',
      mail_address: 'メールアドレス',
      avatar: 'プロフィール写真',
      year: '西暦',
      month: '月',
      day: '日',
      zip_code: '郵便番号（ハイフンなし）',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
      status: '有効・無効',
      gender: '性別',
    },
    zip_code: '郵便番号',
  },
  detail_fields: {
    id: '会員コード',
    nickname: 'ニックネーム',
    birthday: '生年月日',
    gender: '性別',
    address: '住所',
    tel: '電話番号',
    mail_address: 'メールアドレス',
    created_at: '初回登録日',
    last_login_datetime: '最終ログイン日',
    password: 'パスワード',
    status: '有効・無効',
    point: '所有ココロン',
    user_point: '累計消費ココロン',
  },
  users_info: 'アカウント情報',
  users_point: '所有ココロン',
  description_reply: '自己紹介・返信メッセージ',
}
